import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import '../../styles/connections.css';
import { journalS3Section, JOURNAL_S3_TABS } from './searchTable';

// SM4. «Журналы S3»: вкладки «Выгрузки» (SM3, каталог суток) и «Поиск по IP» (кто выходил с адреса в момент).
const JournalS3Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const active = journalS3Section(location.pathname);

  return (
    <div className="pm-content-fade-in">
      <div className="conn-shell-header">
        <div className="conn-shell-header__main">
          <h1 className="conn-shell-header__title">Журналы S3</h1>
          <div className="conn-shell-header__tabs" role="tablist" aria-label="Разделы журналов S3">
            {JOURNAL_S3_TABS.map((tab) => {
              const isActive = tab.key === active;
              return (
                <button
                  key={tab.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  className={`conn-section-chip${isActive ? ' conn-section-chip--active' : ' conn-section-chip--outline'}`}
                  onClick={() => { if (location.pathname !== tab.path) navigate(tab.path); }}
                  tabIndex={0}
                >
                  <span className="conn-section-chip__label">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default JournalS3Layout;
